import React, { createContext, useContext, useRef } from "react";
import { BluetoothManager } from "./bluetoothManager";

const BluetoothContext = createContext<BluetoothManager | null>(null);

export function BluetoothProvider({ children }: { children: React.ReactNode }) {
  const managerRef = useRef(new BluetoothManager());

  return (
    <BluetoothContext.Provider value={managerRef.current}>
      {children}
    </BluetoothContext.Provider>
  );
}

export function useBluetoothManager() {
  const ctx = useContext(BluetoothContext);
  if (!ctx) throw new Error("BluetoothProvider missing");
  return ctx;
}
